import DefaultCommunity from "./defaultCommunity";

export default DefaultCommunity